<template>
  <div class="binding-phone-box">
    <div class="content">
      <verification
        title="验证码登录"
        agreementText="登录即代表同意"
        btnName="登录"
        smsType="5"
        @callSubmit="submit"
      ></verification>
      <div class="row">
        <span @click="toPasswordLogin">密码登录</span>
        <span @click="showTip">收不到验证码？</span>
      </div>
    </div>
  </div>
</template>

<script>
import verification from "@/components/login/verification.vue";
import userApi from "@/api/userApi";
import accountApi from "@/api/accountApi";
import { setToken, setUserId } from "@/libs/util";

export default {
  data() {
    return {
      bindToken: ""
    };
  },
  mounted() {
    this.bindToken = this.$route.query.bind_token;
  },
  components: {
    verification
  },
  methods: {
    submit(phone, smsCode) {
      let data = {
        phone: phone,
        send_code: smsCode,
        invitation_code: "",
        imei: "",
        type: "login"
      };
      userApi.login(data).then(res => {
        if (res.user_id != undefined) {
          setUserId(res.user_id);
          setToken(res.token);
          this.$store.commit("setUserObj", {
            phone: res.phone,
            realname: res.realname,
            user_id: res.user_id,
            user_type_name: res.user_type_name,
            user_type: res.user_type
          });

          // 获取用户银行卡信息
          accountApi.accountBank().then(resp => {
            if (resp.id !== undefined) {
              this.$store.commit("setAccountBankObj", resp);
            }
          });

          // 记录登录账号
          window.localStorage.setItem("loginPhone", phone);

          if (parseInt(res.is_set_login_pwd, 10) === 0) {
            // 没有设置登录密码，去设置登录密码
            this.$router.push({
              name: "setPassword"
            });
          } else {
            this.$router.push({
              name: "myUserHome"
            });
          }
        }
      });
    },
    showTip() {
      this.$dialog.alert({
        title: "收不到验证码？",
        message:
          "1.请检查是否输入正确手机号或邮箱\n2.检查手机号是否停机、空号、暂停服务、关机、不在服务区\n3.请使用其他账号登录\n4.手机号在黑名单(平台或运营商)",
        messageAlign: "left",
        showConfirmButton: true,
        confirmButtonText: "知道了",
        closeOnClickOverlay: true,
        confirmButtonColor: "#8a3e2f"
      });
    },
    toPasswordLogin() {
      this.$router.push({
        name: "Login"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.row {
  padding: 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-size: 12px;
    color: #666666;
  }
}
</style>
